<!-- <FormTextArea
      name="message"
      v-model="form.message"
      label="Ваше сообщение"
    /> -->

<template>
  <div ref="formTextarea"
    class="form-textarea"
    :class="classes">
    <div class="form-textarea__inner">
      <textarea v-bind="$attrs"
        :id="name"
        v-model="inputValue"
        :name="name"
        :placeholder="placeholder"
        class="form-textarea__field"
        type="text"
        @focus="handleFocus"
        @blur="handleBlur" />
    </div>

    <transition name="error"
      appear>
      <div class="form-textarea__error">
        Вы точно не хотите ничего сказать?
      </div>
    </transition>
  </div>
</template>

<script>
import { computed, reactive } from "vue";

export default {
  name: "FormTextArea",

  props: {
    name: {
      type: String,
      default: "inputName",
    },
    placeholder: {
      type: [String, Boolean],
      default: false,
    },
    isDark: {
      type: [String, Boolean],
      default: false,
    },
  },

  setup(props) {
    props = reactive(props);

    return {
      classes: computed(() => ({
        "_is-dark": props.isDark,
      })),
    };
  },

  data() {
    return {
      inputValue: "",
      isFixedLabel: false,
    };
  },

  mounted() {
    if (this.value) {
      this.inputValue = this.value;
      this.isFixedLabel = true;
    }
  },

  methods: {
    handleFocus() {
      this.isFixedLabel = true;

      this.$refs.formTextarea.classList.remove("_error");
    },

    handleBlur(event) {
      const inputValue = event.currentTarget.value;

      if (!inputValue) {
        this.isFixedLabel = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-textarea {
  $that: &;

  position: relative;

  &__inner {
    overflow-y: hidden;
    position: relative;
  }

  &__label {
    position: absolute;
    padding-left: 16px;
    top: 16px;
    left: 0;
    width: 100%;
    color: $color_dark-50;
    pointer-events: none;
    transform: translateZ(0);
    transition: transform 0.3s ease;
    transform-origin: top left;

    ._is-dark & {
      color: $color_dark-40;
    }

    &._fixed-label {
      transform: scale(0.75) translateY(-16px);
    }
  }

  &__field {
    padding: 15px 28px;
    width: 100%;
    height: 158px;
    border: 1px solid #2E2F39;
    border-radius: 23px;
    background-color: $color_dark-20;
    font-size: 14px;

    @include phone {
      padding: 15px 20px;
      font-size: 16px !important;
    }

    ._is-dark & {
      background-color: $color_dark-70;
      color: $white;
    }

    &::placeholder {
      color: currentColor;
      text-transform: uppercase;
      letter-spacing: .5px;
    }
  }

  &__error {
    color: $color_primary;
    margin-top: 2px;
    font-size: 12px;
    line-height: 16px;
    opacity: 0;
    visibility: hidden;

    ._error & {
      opacity: 1;
      visibility: visible;
    }
  }

  .error-enter-active {
    transition: opacity 0.5s, transform 0.5s;
  }

  .error-leave-active {
    transition: opacity 0.25s, transform 0.25s;
  }

  .error-enter {
    opacity: 0;
    transform: translate(8px, 0);
  }

  .error-leave-to

  /* .fade-leave-active до версии 2.1.8 */
    {
    opacity: 0;
    transform: translate(0, 2px);
  }
}
</style>
